import React from 'react'
import {useParams} from "react-router-dom";
import {useQuery} from "react-query";
import {getVictimById, getVictimStatuses, updateVictim} from "../../../services/victimSvc";
import moment from "moment";
import imgBaseUrl from "../../../utils/imgBaseUrl";
import {PLACEHOLDER_IMAGE_URL} from "../../../mock/constants";
import phoneFormatter from "../../../utils/phoneFormatter";
import {EmptySection} from "../../../components/sections/empty/Empty";
import {LoaderSection} from "../../../components/sections/loader/Loader";
import {useNotification} from "../../../context/NotificationContext";
import {useFormik} from "formik";

export const VictimResponsePage = () => {
  const {victimId} = useParams()
  const {
    data: victimById,
    isError: victimIsError,
    isLoading: victimIsLoading,
    refetch: refetchVictim
  } = useQuery("getVictimById", () => getVictimById(Number(victimId)))
  const {showNotification} = useNotification()

  const handleAnswerSubmit = async (values) => {
    try {
      const res = await updateVictim(Number(victimId), values)
      showNotification("Muvaffaqiyatli", "Javob yuborildi", "success")
      refetchVictim()
    } catch (e) {
      showNotification("Xatolik", "", "error")
    }
  }

  const formik = useFormik({
    initialValues: {
      answer: victimById?.answer || "",
      status: victimById?.status || ""
    },
    onSubmit: async (values) => {
      values.status = Number(values.status)
      handleAnswerSubmit(values)
    }
  })

  const {
    data: victimStatus,
    isLoading: victimStatusIsLoading,
    refetch: refetchVictimStatus
  } = useQuery(["getVictimStatuses"], () => getVictimStatuses({
    params: {
      page_size: 1000
    }
  }))

  if (victimIsError) return <EmptySection height={"50vh"}/>
  if (victimIsLoading) return <LoaderSection height={"50vh"}/>

  return (
      <div className={"card"}>
        <div className="card-header">
          <h3 className="card-title">Viktimlik arizasi</h3>
        </div>
        <div className="card-body">
          <div>
            <div className={"d-flex align-items-center mb-5"}>
              <div className='symbol symbol-45px me-3'>
                <img className={"object-fit-cover"}
                     src={victimById?.user?.avatar ? imgBaseUrl(victimById?.user?.avatar!) : PLACEHOLDER_IMAGE_URL}
                     alt={`${victimById?.user?.first_name} ${victimById?.user?.last_name}`}/>
              </div>

              <div className={"d-flex flex-column"}>
                <span>{victimById?.user?.first_name} {victimById?.user?.last_name}</span>
                <span>{phoneFormatter(victimById?.user?.phone!)}</span>
              </div>
            </div>
            <div className={"border border-secondary w-100 w-md-75 bg-light-secondary p-5 rounded-4"}>
              <span className={"small text-muted"}>Ariza matni</span>
              <p className={"p-0 m-0"}>{victimById?.message}</p>
            </div>
            <span
                className={"d-block text-muted small mt-2"}>{moment(victimById?.created_at).format("DD.MM.YYYY HH:mm:ssss")}</span>
          </div>
          <div className={"d-flex justify-content-end mt-10"}>
            <div className={"w-100 w-md-75"}>
              {victimById?.answer ? <div>
                <div className={"border border-primary bg-light-primary p-5 rounded-4"}>
                  <span className={"small text-primary"}>Javob matni</span>
                  <p className={"p-0 m-0"}>{victimById?.message}</p>
                </div>
                <span
                    className={"d-block text-muted small mt-2"}>{moment(victimById?.created_at).format("DD.MM.YYYY HH:mm:ssss")}</span>
              </div> : <div>
                <form onSubmit={formik.handleSubmit}>
                  <div>
                    <label className={"form-label"}>Javob matni</label>
                    <textarea name="answer" onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              cols={30} rows={10} className={"form-control"}
                              placeholder={"Javob matnini kiriting"}></textarea>
                  </div>

                  <div className={"mt-5"}>
                    <label className={"form-label"}>Viktimlik arizasi statusini tanlang</label>
                    <select className={"form-select"} name="status" onChange={formik.handleChange}
                            onBlur={formik.handleBlur}>
                      <option hidden value="">-- Status tanlang --</option>
                      {victimIsLoading ? "Yuklanmoqda" : victimStatus?.data.length === 0 ? "Bo'sh" : victimStatus?.data?.map((status) => (
                          <option key={status?.id} value={status.id}>{status?.name}</option>
                      ))}
                    </select>
                  </div>
                  <div className={"text-end"}>
                    <button
                        disabled={
                            formik.isSubmitting || !formik.dirty || !formik.isValid || !formik.values.answer || !formik.values.status
                        }
                        type="submit" className={"btn btn-primary mt-5"}>Yuborish
                    </button>
                  </div>
                </form>
              </div>
              }
            </div>
          </div>
        </div>
      </div>
  )
}
